// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__Rh4ge","powered":"style_powered__UQN19","version":"style_version__3lkyg"};